import React, { useEffect, useState } from 'react';
import { CircularChart3D, PieSeries3D, CircularChartDataLabel3D, CircularChartLegend3D, CircularChartTooltip3D, CircularChartHighlight3D } from '@syncfusion/ej2-charts';
import { enableRipple, Browser } from '@syncfusion/ej2-base';
import { formatCurrency } from '../../utils/Format';

CircularChart3D.Inject(PieSeries3D, CircularChartDataLabel3D, CircularChartLegend3D, CircularChartTooltip3D, CircularChartHighlight3D);

const EtatsChart = ({ data, title = '', valeur = "Etat", montant = null }) => {
    const [chartData, setChartData] = useState([]);
    const chartContainerRef = React.useRef(null);

    const tooltipRender = (args) => {
        const value = args.point.y;
        const label = args.point.x;

        if (montant) {
            args.text = `<b>${label}</b><br>Montant: <b>${formatCurrency(value)}</b>`;
        } else {
            args.text = `<b>${label}</b><br>Nombre: <b>${value}</b>`;
        }
    };

    useEffect(() => {
        if (data && data.length > 0) {
            let groupedData = {};

            if (!montant) {
                groupedData = data.reduce((acc, curr) => {
                    const key = curr[valeur];
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {});
            } else {
                groupedData = data.reduce((acc, curr) => {
                    const key = curr[valeur];
                    const currentAmount = curr[montant] || 0;
                    acc[key] = (acc[key] || 0) + currentAmount;
                    return acc;
                }, {});
            }

            const total = Object.values(groupedData).reduce((a, b) => a + b, 0);

            const formattedData = Object.keys(groupedData).map((key) => {
                const value = groupedData[key];
                const label = key?.trim() ? key : "Non renseigné";
                const percent = total > 0 ? ((value / total) * 100).toFixed(1) : 0;

                return {
                    x: label,
                    y: value,
                    text: `${percent}%`
                };
            });

            setChartData(formattedData);

        }
    }, [data, valeur, montant]);

    useEffect(() => {
        if (chartData.length > 0 && chartContainerRef.current) {
            let pie = new CircularChart3D({
                series: [
                    {
                        dataSource: chartData,
                        xName: 'x',
                        yName: 'y',
                        radius: Browser.isDevice ? '45%' : '65%',
                        innerRadius: '20%',
                        explode: true,
                        explodeOffset: '10%',
                        dataLabel: {
                            visible: true,
                            position: 'Inside',
                            name: 'text',
                            font: { fontWeight: '500' },
                            connectorStyle: { length: '10px' }
                        },
                    },
                ],
                title: title,
                legendSettings: { visible: true },
                tooltip: {
                    enable: true,
                    format: '${point.x}: <b>${point.y}</b>',
                    header: '',
                    position: 'Top',
                },
                tooltipRender: tooltipRender,
                enableRotation: true,
                tilt: -30,
                load: (args) => {
                    let selectedTheme = 'Material';
                    args.chart.theme = selectedTheme;
                }
            });

            pie.appendTo(chartContainerRef.current);

            return () => {
                if (pie) {
                    pie.destroy();
                }
            };
        }
    }, [chartData]);

    return <div ref={chartContainerRef} className="w-full h-96"></div>;
};

export default EtatsChart;
